/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Funnel(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M228.54736,49.52637A15.80639,15.80639,0,0,0,213.91553,40H42.08447A16.00043,16.00043,0,0,0,30.24561,66.76367L96,139.09277v77.959a15.99388,15.99388,0,0,0,24.875,13.3125l31.99951-21.332A15.96822,15.96822,0,0,0,160,195.71875v-56.625l65.75488-72.331A15.80708,15.80708,0,0,0,228.54736,49.52637Z" />
    </Svg>
  );
}

export default Funnel;
